import { AmazonOrderGlobalBinded } from './../models/Orders';
import { BillConceptos } from './../models/Factura';

export const ordersToConceptos = (orders: AmazonOrderGlobalBinded[]) => {
    return orders.reduce((p, c) => {
        c.taxing.forEach((t, i) => {
            let valorUnitario = t.subtotal;
            // Check if IEPS applies
            const iepsTasa = t.taxes.filter(tax => tax.type === 'ieps').reduce((_p, tax) => _p += tax.tasa, 0);
            if (iepsTasa) {
                valorUnitario = valorUnitario / (1 + iepsTasa);
            }

            const entry: BillConceptos = {
                claveProdServ: '01010101',
                claveUnidad: 'ACT',
                descripcion: "venta",
                noIdentificacion: `${c.order.AmazonOrderId}${i > 0 ? '-' + i : ''}`,
                valorUnitario: valorUnitario,
                cantidad: 1,
                impuestos: t.taxes.map((tax) => ({ type: tax.type, tasa: tax.tasa, retencion: false }))
            }
            p.push(entry);
        })
        return p;
        /*
        const valorUnitarioBase = c.order.OrderTotal.Amount;
        const valorUnitario = valorUnitarioBase / 1.16;
        const entry: BillConceptos = {
            claveProdServ: '01010101',
            claveUnidad: 'ACT',
            descripcion: "venta",
            noIdentificacion: `${c.order.AmazonOrderId}`,
            valorUnitario: valorUnitario,
            cantidad: 1,
            impuestos: [{
                tasa: 0.16,
                type: 'iva',
                retencion: false
            }]
        }
        p.push(entry);
        return p;
        */
    }, [] as BillConceptos[]);
} 